import * as t from './actionTypes';
import { ReportMetric } from './types';

export function fetchMetricsRequest() {
  return {
    type: t.FETCH_METRICS_REQUEST,
  };
}
export function fetchMetricsResponse(metrics: ReportMetric[]) {
  return {
    type: t.FETCH_METRICS_RESPONSE,
    metrics,
  };
}
export function fetchMetricsError(error: any) {
  return {
    type: t.FETCH_METRICS_ERROR,
    error,
  };
}
